import { render } from "./sub-categories.vue?vue&type=template&id=1b92e6c3"
import script from "./sub-categories.vue?vue&type=script&lang=js"
export * from "./sub-categories.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__